export interface SubNavItem {
  order: string;
  subheader: string;
  title?: string;
  path: string;
  cover: string;
}

export interface NavItem {
  title: string;
  path: string;
  children?: SubNavItem[];
}

export type NavConfig = NavItem[]

export const ROUTES = {
  SERVICE: {
    landing: '/services',
    general: '/services/general',
    special: '/services/special',
    prevention: '/services/prevention'
  },
  ABOUT: '/about',
  CONTACT: '/contact',
  HOME: '/'
};

export const navConfig: NavConfig = [
  {
    title: 'Home',
    path: ROUTES.HOME
  },
  {
    title: 'About',
    path: ROUTES.ABOUT
  },
  {
    title: 'Services',
    path: ROUTES.SERVICE.landing,
    children: [
      {
        order: '1',
        subheader: '',
        title: 'General',
        path: ROUTES.SERVICE.general,
        cover: '/assets/svgs/vector4.svg',
      },
      {
        order: '2',
        subheader: '',
        title: 'Special',
        path: ROUTES.SERVICE.special,
        cover: '/assets/svgs/vector2.svg',
      },
      {
        order: '3',
        subheader: '',
        title: 'Prevention',
        path: ROUTES.SERVICE.prevention,
        cover: '/assets/svgs/vector3.svg',
      }
    ]
  },
  {
    title: 'Contact',
    path: ROUTES.CONTACT
  }

];
